import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import DashboardCard from "../../../pages/home/common/DashboardCard";
import {
  convertThenFormat,
  formatTimezoneThenStraight,
} from "../../common-data/Converts";
import { getCardLabel, getCardValue, keyMapping } from "./RawLeadCommon";
import ReactCountUp from "../../components-react/ReactCountUp";

const RawLeadStatCards = ({
  userInfoData,
  tableRef,
  allFilters,
  setAllFilters,
}) => {
  const { rawLeadStatsLoading, rawLeadStats } = useSelector(
    (state) => state.api
  );

  const [leadStatsData, setLeadStatsData] = useState(
    rawLeadStats?.data ? rawLeadStats.data?.[0] : null
  );
  const [lastAssigned, setLastAssigned] = useState(
    rawLeadStats?.last_assigned ? rawLeadStats.last_assigned : null
  );

  const handleCardClick = (key, _) => {
    const keyName = key?.replace(/_/g, " ");

    setAllFilters((prevs) => ({
      ...prevs,
      clickedCard: key,
      selFilterType: {
        label: keyName,
        value: getCardValue(key?.replace(/ /g, "_")),
      },
    }));

    tableRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (rawLeadStats?.status) {
      setLeadStatsData(rawLeadStats?.data?.[0] || null);
      setLastAssigned(rawLeadStats?.last_assigned || null);
    } else {
      setLeadStatsData(null);
      setLastAssigned(null);
    }
  }, [rawLeadStats]);

  return (
    <>
      {lastAssigned && (
        <div className="counter-up-container flexStart mt30">
          <div className="alert alert-danger" role="alert">
            Last Lead Assign Pending Since (
            {lastAssigned?.date_added
              ? formatTimezoneThenStraight(lastAssigned.date_added)
              : ""}
            ) : <ReactCountUp dateAndTime={lastAssigned?.date_added} />
          </div>
        </div>
      )}

      {rawLeadStatsLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="cards-container cards-grid-container lead-cards grid-4 mt-2rem">
          {leadStatsData &&
            Object.entries(leadStatsData).map(([key, value], index) => {
              const compareKey =
                key !== "added_from_trial" && (keyMapping[key] || key);

              return (
                <React.Fragment key={index}>
                  {key !== "added_from_trial" && (
                    <DashboardCard
                      tagName={key}
                      cardLabel={
                        keyMapping[key]
                          ? keyMapping[key]?.replace(/_/g, " ")
                          : getCardLabel(key)
                      }
                      value={`${convertThenFormat(value || 0)}`}
                      onClickCard={handleCardClick}
                      isLead={true}
                      isUseTagname={true}
                      cardIndex={index}
                      isActiveCard={
                        allFilters.selFilterType?.value === compareKey
                      }
                    />
                  )}
                </React.Fragment>
              );
            })}
        </div>
      )}
    </>
  );
};

export default RawLeadStatCards;
